import React from "react";
import { useNavigate } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

interface LogoProps {
  buttonType?: "primary" | "secundary";
  fontSize?: "big" | "normal";
}

export const Logo: React.FC<LogoProps> = ({
  buttonType = "secundary",
  fontSize = "normal"
}) => {
  const navigate = useNavigate();
  const color = buttonType === "primary" ? "black" : "#FFF";
  const font = fontSize === "big" ? "4.6rem" : "1.2rem";

  return (
    <Box
      onClick={() => navigate("/")}
      sx={{
        cursor: "pointer",
        transition: "opacity 0.2s",
        "&:hover": {
          opacity: 0.8,
        },
      }}
    >
      <Typography
        sx={{
          fontSize: font,
          textAlign: "center",
          color: color,
          fontWeight: "700",
        }}
      >
        OC
        <span style={{ color: "#FF006F" }}>.</span>
      </Typography>
    </Box>
  );
};
